<template>
    <div class="kt-portlet kt-portlet--height-fluid" id="recentactivities">
        <div class="kt-portlet__head">
            <div class="kt-portlet__head-label">
                <h3 class="kt-portlet__head-title">{{ i18n("views.Index.NewActivities") }}</h3>
            </div>
        </div>
        <div class="kt-portlet__body kt-scroll" data-scroll="true" style="height: 400px">
            <div class="kt-widget3"></div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import { i18n } from "@/portal/Trans";
    import { ActivityFeed } from "@/portal/elements/ActivityFeed";
    import { onMounted } from "vue";

    let $recentActivityBox: JQuery;

    onMounted(() => {
        $recentActivityBox = $("#recentactivities");
        if ($recentActivityBox.length > 0) {
            new ActivityFeed($recentActivityBox);
        }
    });
</script>
